import { SelectOption } from '../../shared/components/forms/select';

// Backend locale codes with endonym labels, shared by the tenant "User
// defaults" section and the personal preferences page. Endonyms are
// deliberately not translated: a language's own name does not change with
// the UI language.
export const LOCALE_OPTIONS: SelectOption[] = [
  { value: 'en-GB', label: 'English' },
];

// IANA zone ids are shown verbatim; they are identifiers, not copy.
export const TIMEZONE_OPTIONS: SelectOption[] = [
  'UTC',
  'Europe/London',
  'Europe/Berlin',
  'Europe/Ljubljana',
  'Asia/Dubai',
].map((z) => ({ value: z, label: z }));

/** Display label for a locale code; unknown codes fall back to the raw code. */
export function localeLabel(code: string): string {
  return LOCALE_OPTIONS.find((o) => o.value === code)?.label ?? code;
}
